import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createCategory } from "../../helpers/http_categories_requests";

export default function CategoryNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Cadastro de Produto",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createCategory(data, () => navigate('/categorias'))
    };

    return <DynamicFormPage title={"Categorias - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
